import { Injectable } from '@angular/core';
import { Observable, EMPTY, of } from 'rxjs';
import {
  IUpdateService,
  UpdateInfo,
  UpdateDownloadProgress,
} from '@infinitform/platform-core';

@Injectable()
export class UpdateCloudService implements IUpdateService {
  checkForUpdates(): Observable<UpdateInfo | null> {
    return of(null);
  }

  downloadUpdate(): Observable<{ success: boolean; error?: string }> {
    return of({ success: false, error: 'Updates not available on cloud' });
  }

  cancelDownload(): void {
    // no-op
  }

  installUpdate(): void {
    // no-op
  }

  onUpdateAvailable(): Observable<UpdateInfo> {
    return EMPTY;
  }

  onDownloadProgress(): Observable<UpdateDownloadProgress> {
    return EMPTY;
  }

  onDownloadComplete(): Observable<void> {
    return EMPTY;
  }

  onError(): Observable<{ message: string }> {
    return EMPTY;
  }
}
